import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'

import 'buefy/dist/buefy.css'
import '@/scss/main.scss'
import '@mdi/font/css/materialdesignicons.css'

import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import aws_exports from './aws-exports'
Amplify.configure(aws_exports)

import DefaultLayout from '@/layouts/Default'

Vue.use(Buefy)
Vue.use(AmplifyPlugin, AmplifyModules)

Vue.config.productionTip = false

// i18n
import languageDict from './lang'
AmplifyModules.I18n.putVocabularies(languageDict)

// layouts
Vue.component('default-layout', DefaultLayout)

new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App />'
})
